var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 9.25L4.05 6.425L12 2L19.95 6.425L14.9 9.25C14.5167 8.85 14.075 8.54167 13.575 8.325C13.075 8.10833 12.55 8 12 8C11.45 8 10.925 8.10833 10.425 8.325C9.925 8.54167 9.48333 8.85 9.1 9.25ZM11 21.45L3 17V8.125L8.125 11C8.075 11.1667 8.04167 11.3293 8.025 11.488C8.00833 11.6467 8 11.8173 8 12C8 12.9167 8.275 13.7333 8.825 14.45C9.375 15.1667 10.1 15.6417 11 15.875V21.45ZM12 14C11.45 14 10.979 13.8043 10.587 13.413C10.195 13.0217 9.99933 12.5507 10 12C10 11.45 10.196 10.979 10.588 10.587C10.98 10.195 11.4507 9.99933 12 10C12.55 10 13.021 10.196 13.413 10.588C13.805 10.98 14.0007 11.4507 14 12C14 12.55 13.804 13.021 13.412 13.413C13.02 13.805 12.5493 14.0007 12 14ZM13 21.45V15.875C13.9 15.6417 14.625 15.1667 15.175 14.45C15.725 13.7333 16 12.9167 16 12C16 11.8167 15.9917 11.6457 15.975 11.487C15.9583 11.3283 15.925 11.166 15.875 11L21 8.125V17L13 21.45Z",
    fill: "#13599D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsToken);
export default __webpack_public_path__ + "static/media/material-symbols_token.e2581dea6c838e0e635bae0082b9bae9.svg";
export { ForwardRef as ReactComponent };